import { Card, CardBody, CardFooter, Col, Row, Alert, Button, CustomInput, Input } from 'reactstrap';
import React, { useEffect, useState } from 'react'
import PageHeader from '../common/PageHeader'
import withRedirect from '../../helpers/hoc/withRedirect';
import FalconCardHeader from '../common/FalconCardHeader';
import ButtonIcon from '../common/ButtonIcon';
import { faExclamation, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import FullPagination from '../common/pagination/FullPagination';
import { If, Message, Or, PreloadState } from '../UI/preloading/PreloadState';
import { isIterableArray } from '../../helpers/utils';
import { useSelector } from 'react-redux';
import useSWRFetchPagination from '../../helpers/hooks/useSWRFetchPagination';
import { getAllComplaints } from './../../helpers/api/complaints';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import Notification from './components/Notification';
import SupportLink from '../root/support/components/SupportLink';

const Complain = ({ setRedirectUrl, setRedirect }) => {

    const { selectedCondominium } = useSelector(state => state.condominium);
    const { role } = useSelector(state => state.auth.user);
    const location = useLocation();
    const [textSearch, setTextSearch] = useState('');
    const [params, setParams] = useState({
        condominium: selectedCondominium,
        search: null,
        closed: 0,
    });

    useEffect(() => {
        setParams((prev) => (
            prev.condominium === selectedCondominium
                ? prev
                : { ...prev, condominium: selectedCondominium }
        ));
    }, [selectedCondominium]);

    const applyComplaintSearch = (value = textSearch) => {
        const term = typeof value === 'string' ? value.trim() : '';
        setTextSearch(term);
        setParams((prev) => ({ ...prev, search: term || null }));
    };
    const {
        data,
        error,
        isLoading,
        meta,
        handler: { nextPage, previousPage, perPage, goToPage }
    } = useSWRFetchPagination(getAllComplaints, params);

    const renderComplainItems = () => {
        return data.map((item, i) => {
            return <Notification
                index={i}
                key={i}
                {...{
                    to: item.id,
                    author: item.author,
                    avatar: item.author.image,
                    time: item.created_at,
                    className: '',
                    unread: '',
                    flush: '',
                    closed: item.closed,
                    title: item.title,
                }} />
        })
    }

    return (
        <>
            <PageHeader
                title="Sugerencias" titleTag="h2"
                description={(role === 'property' || role === 'safety') ? 'Si tienes alguna sugerencia comunicanos, nuestra finalidad es ayudar a los usuarios para que puedan resolver inconvenientes.' : 'Responde a las sugerencias de los usuarios del condominio.'}
                className="mb-3" col={{ lg: 9 }}
            >
                {role === 'manager' && <SupportLink />}
            </PageHeader>
            <Card>
                <FalconCardHeader title='Sugerencias'>
                    <Row>
                        <Col md={12} lg={6} className="d-flex">
                            <Input
                                type='text'
                                value={textSearch}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') applyComplaintSearch(e.target.value);
                                }}
                                onChange={(event) => {
                                    const value = event.target.value;
                                    setTextSearch(value);
                                    if (!value.trim()) {
                                        setParams((prev) => ({ ...prev, search: null }));
                                    }
                                }}
                                placeholder="Buscar por título, descripción, respuesta, inmueble, nombre, usuario o cédula..."
                                className="d-inline-block search-input mr-2" />
                            <Button className='d-inline-block' color='falcon-default' onClick={() => applyComplaintSearch()} >Buscar</Button>
                        </Col>

                        <Col md={12} lg={6} className={`d-flex mt-3 mt-lg-0 justify-content-center justify-content-lg-end align-items-center`}>
                            {!params.closed ? 'Casos abiertos' : 'Casos cerrados'}
                            <CustomInput
                                style={{ cursor: 'pointer' }}
                                className='mr-2 ml-2'
                                type="switch"
                                id="cases"
                                bsSize='lg'
                                checked={params.closed}
                                onChange={({ target }) => setParams((prev) => { return { ...prev, closed: target.checked ? 1 : 0 } })}
                            />
                        </Col>
                        <If cond={['property', 'safety']}>
                            <Col value={role} className='mt-3 text-center text-md-right'>
                                <ButtonIcon icon={faPlus} tag={Link} to={`${location.pathname}/create`} color='falcon-default' >Añadir sugerencia</ButtonIcon>
                            </Col>
                        </If>
                    </Row>
                </FalconCardHeader>
                <CardBody className={isIterableArray(data) ? 'fs--1 p-0' : 'fs--1'}>
                    <PreloadState cond={isIterableArray(data)} loading={isLoading}>
                        <Or value={true}>
                            {renderComplainItems()}
                        </Or>
                        <Or value={false} cond={!!error}>
                            <Or value={false} cond={role}>
                                <Or value={'manager'} cond={!!textSearch[0]}>
                                    <Message value={true} color={'info'} className='p-3' align='left' icon={faExclamation}>
                                        <>No hemos encontrado una sugerencia con el nombre "{textSearch}".</>
                                    </Message>
                                    <Message value={false} color={'info'} className='p-3' align='left' icon={faExclamation}>
                                        Aún no hay sugerencias en este condominio.
                                    </Message>
                                </Or>
                                <Or value={'safety'} cond={!!textSearch[0]}>
                                    <Message value={true} color={'info'} className='p-3' align='left' icon={faExclamation}>
                                        <>No hemos encontrado una sugerencia con el nombre "{textSearch}".</>
                                    </Message>
                                    <Message value={false} color={'info'} className='p-3' align='left' icon={faExclamation}>
                                        Aún no hay sugerencias en este condominio.
                                    </Message>
                                </Or>
                                <Or value={'property'} cond={!!textSearch[0]}>
                                    <Message value={true} color={'info'} className='p-3' align='left' icon={faExclamation}>
                                        <>No hemos encontrado una sugerencia con el nombre <b>"{textSearch}"</b>.</>
                                    </Message>
                                    <Message value={false} color={'info'} className='p-3' align='left' icon={faExclamation}>
                                        Aún no hay sugerencias en este condominio.
                                    </Message>
                                </Or>
                            </Or>
                            <Or value={true}>
                                <Alert color="danger" className="mb-0">
                                    Esta página no está disponible
                                    <Button data-testid="Button" color="link" size="sm" className="ml-1 pl-0" onClick={() => { setRedirectUrl(`/dashboard/banks`); setRedirect(true) }}>
                                        Volver
                                    </Button>
                                </Alert>
                            </Or>
                        </Or>
                    </PreloadState>
                </CardBody>

                {isIterableArray(data) &&
                    <CardFooter>
                        <FullPagination
                            nextPage={nextPage}
                            prevPage={previousPage}
                            goToPage={goToPage}
                            meta={meta}
                            className={'shadow-none'}
                            posText={"sugerencias"}
                            perPage={perPage} />
                    </CardFooter>}
            </Card>
        </>
    )
}

export default withRedirect(Complain);